import { render, staticRenderFns } from "./FileDropTarget.vue?vue&type=template&id=863be8b0&"
import script from "./FileDropTarget.vue?vue&type=script&lang=ts&"
export * from "./FileDropTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports